import { createAction, props } from '@ngrx/store';
import { IObject } from './objects.models';

export const setObjects = createAction(
  '[Objects] Set Objects',
  props<{ objects: ReadonlyArray<IObject> }>()
);

export const selectObject = createAction(
  '[Objects] Select Object',
  props<{ object: IObject }>()
);

export const setSelectedProductPrice = createAction(
  '[Objects] Set Product Price',
  props<{ selectedProductPrice: number }>()
);

export const resetSelectedObject = createAction(
  '[Objects] Reset Object selected'
);
